import {
  GET_POSTALCODES_SUCCESS,
  GET_POSTALCODES_FAILED,
  GET_POSTALCODES_INVALID_WALLET_ID,
  GET_POSTALCODES_INVALID_TOKEN,
  RESET_GET_POSTALCODES,
  LOADING_GET_POSTALCODES,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  notFound: false,
  invalidToken: false,
  postalCodes: [],
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GET_POSTALCODES:
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        notFound: false,
        invalidToken: false,
        status: "",
        networkError: "",
      };

    case GET_POSTALCODES_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        notFound: false,
        invalidToken: false,
        status: action.payload.status,
        postalCodes: [],
        networkError: "",
      };

    case GET_POSTALCODES_INVALID_TOKEN:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        notFound: false,
        invalidToken: true,
        status: action.payload.status,
        networkError: "",
      };

    case GET_POSTALCODES_INVALID_WALLET_ID:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        notFound: true,
        invalidToken: false,
        status: action.payload.status,
        networkError: "",
      };

    case GET_POSTALCODES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        notFound: false,
        invalidToken: false,
        postalCodes: action.payload.postalCodes,
        networkError: "",
      };
    }

    case RESET_GET_POSTALCODES:
      return (state = initialState);

    default:
      return state;
  }
};
